<button
  type="button"
  class="block p-sm hover:bg-gray-100 flex items-center gap-sm w-full text-start"
  role="menuitem"
  [id]="'profile_dropdown_item_' + item().slug + '_button'"
  (click)="onItemClick()"
  tabindex="-1">
  <!-- Menu Item Icon -->
  <ng-container
    [ngTemplateOutlet]="menuContent"
    [ngTemplateOutletContext]="{ $implicit: item() }" />

  <div class="flex flex-col me-auto">
    <!-- main text -->
    <p
      class="text-xs font-medium"
      [class]="item().itemClass || 'text-neutral-700'">
      {{ item().mainText | transloco }}
    </p>

    <!-- sub text -->
    @if (item().subText) {
      <p class="text-xs2 text-neutral-500 font-medium line-clamp-1 uppercase">
        {{ item().subText }}
      </p>
    }
  </div>

  @if (item().hasSubMenu) {
    <lib-chevron-down-icon
      [iconClass]="'size-5 rotate-270 rtl:rotate-90 text-neutral-500'" />
  }
</button>

<ng-template #menuContent let-item>
  @switch (item.slug) {
    @case (ProfileDropdownItemSlugs.LOGOUT) {
      <lib-logout-icon [iconClass]="'size-5 text-destructive-500'" />
    }

    @case (ProfileDropdownItemSlugs.LANGUAGE) {
      <lib-globe-icon [iconClass]="'size-5 text-neutral-500'" />
    }

    @case (ProfileDropdownItemSlugs.WORKSPACE) {
      <lib-workspace-icon [iconClass]="'size-5 text-neutral-500'" />
    }

    @case (ProfileDropdownItemSlugs.PORTAL) {
      <lib-monitor-icon [iconClass]="'size-5 text-neutral-500'" />
    }
  }
</ng-template>
